import '../styles/globals.css';
import 'cropperjs/dist/cropper.css';
import '@ugc/share/src/polyfill';
import { loadEruda } from '@mx/core';
import { getClientStore, NextClientSideInit, useAuthCheck, getTrackUserInfo } from '@ugc/share';
import { UniToast } from '@ugc/share/src/ui/Components/UniToast';
import { App as AntdAppWrapper, ConfigProvider } from 'antd';
import App from 'next/app';
import { useRouter } from 'next/router';
import { appWithTranslation } from 'next-i18next';
import { useEffect } from 'react';
import { Provider } from 'react-redux';

import theme from '../components/theme/themeConfig';

import { GlobalAntdMessage } from '@/components/message';

function InnerApp({ Component, pageProps }: { Component: any; pageProps: any }) {
  useAuthCheck();

  useEffect(() => {
    // 客户端初始化 Guance SDK
    if (typeof window !== 'undefined') {
      // 确保只在客户端执行
      import('@cloudcare/browser-rum').then(async ({ datafluxRum }) => {
        const { user_id, device_id } = await getTrackUserInfo();
        console.log(
          '===打印guance日志===',
          JSON.stringify({
            user_id,
            device_id,
            __ENV__,
            __APP_VERSION__,
          })
        );
        datafluxRum.init({
          applicationId: 'xingye_web_ugc',
          site: 'https://rum-openway.guance.com',
          clientToken: '3ee1765cbdf142b7ab2983cd75c59c29',
          env: __ENV__,
          version: __APP_VERSION__,
          service: 'browser',
          sessionSampleRate: 10, // 整体采样率
          sessionReplaySampleRate: 0, // 回放ui
          sessionOnErrorSampleRate: 100, // 错误采样率
        });
        datafluxRum.startSessionReplayRecording();
        datafluxRum.setUser({
          id: user_id,
          properties: {
            device_id,
          },
        });
        datafluxRum.setGlobalContextProperty('user.user_id', user_id);
        datafluxRum.setGlobalContextProperty('device.device_id', device_id);
      });

      import('@ugc/share/src/monitor/rum').then(async ({ rumManager }) => {
        const { user_id } = await getTrackUserInfo();

        rumManager.init({
          id: 'aZpbdiDbKjDbJxz8k3',
          version: __APP_VERSION__,
          uin: user_id,
          random: 0.1,
        });
      });
    }
  }, []);

  return (
    <ConfigProvider theme={theme}>
      <AntdAppWrapper message={{ maxCount: 2 }}>
        <Component {...pageProps} />
        <GlobalAntdMessage />
        <UniToast />
      </AntdAppWrapper>
    </ConfigProvider>
  );
}

function TalkieApp({ Component, pageProps }: { Component: any; pageProps: any }) {
  const isClient = typeof window !== 'undefined';
  const store = getClientStore(pageProps.serverState, !isClient);
  const { locale } = useRouter();
  if (isClient) {
    // 初始化 client 逻辑
    NextClientSideInit(store, { locale });
  }

  loadEruda();

  return (
    <Provider store={store}>
      <InnerApp Component={Component} pageProps={pageProps} />
    </Provider>
  );
}

TalkieApp.getInitialProps = async (appContext: any) => {
  const appProps = await App.getInitialProps(appContext);
  return { ...appProps };
};

export default appWithTranslation(TalkieApp);
